let config = {}
if (window.location.href.indexOf("cashier.greencampus.me") > -1 || process.env.NODE_ENV=='development') {
  config.baseURL = window.location.protocol + '//dev.service.payment.goliveplus.cn';
} else {
  config.baseURL = window.location.protocol + '//payment.zafu.edu.cn';
}
export default config;


// WEBPACK FOOTER //
// ./src/api/isLocalDev.js